import "./App.css";
import "./common.css";
import "./root.css";

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/functions";

import { useAuthState } from "react-firebase-hooks/auth";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import SignIn from "./pages/sign-in/sign-in";
import SuccessfullDeletion from "./pages/successfull-deletion/successfull-deletion";
import LandingPage from "./pages/landing-page/landing-page";
import { default as NavbarLandingPage } from "./pages/landing-page/segments/navbar/navbar";
import { PricingPage } from "./pages/landing-page/segments/pricing/pricing";
import { ContactUsPage, ContactUsSegment } from "./pages/landing-page/segments/contact-us/contact-us";
import { AboutUsPage } from "./pages/landing-page/segments/about-us/about-us";
import { PrivacyPage } from "./pages/landing-page/segments/privacy/privacy";
import { PrivacyPolicyPage } from "./pages/landing-page/segments/privacy/privacy-policy";
import { TermsOfServicePage } from "./pages/landing-page/segments/privacy/terms-of-service";
import { GDPRPage } from "./pages/landing-page/segments/privacy/gdpr";
import { ResponsibleReportingPage } from "./pages/landing-page/segments/privacy/responsible-reporting";
import PrecisionPage from "./pages/landing-page/segments/precision/precision";
import JoinOrganizationAuth from "./pages/join-organization-auth/join-organization-auth";

import { Toaster } from "react-hot-toast";
import ScrollToTop from "./molecules/scrollToTop/scrollToTop";

import { MantineProvider } from "@mantine/core";
import { UserAndOrganzationContextProvider } from "./contexts/userAndOrganizationContext";

import "./i18n";
import { Suspense, useEffect } from "react";
import React from "react";

// Lazy load authenticated components
const Dashboard = React.lazy(() => import("./pages/dashboard/dashboard"));
const Scans = React.lazy(() => import("./pages/scans/scans"));
const Scan = React.lazy(() => import("./pages/scan/scan"));
const Navbar = React.lazy(() => import("./organisms/navbar/navbar"));
const User = React.lazy(() => import("./pages/user/user"));
const DeleteUser = React.lazy(() => import("./pages/delete-user/delete-user"));
const CreateUser = React.lazy(() => import("./pages/create-user/create-user"));
const Unavailable = React.lazy(() => import("./pages/unavailable/unavailable"));
const DataAdministration = React.lazy(() => import("./pages/data-administration/data-administration"));
const DeleteData = React.lazy(() => import("./pages/delete-data/delete-data"));
const NewTestScan = React.lazy(() => import("./pages/new-test-scan/new-test-scan"));
const ExperimentalNewScan = React.lazy(() => import("./pages/experimental-new-scan/experimental-new-scan"));
const NewOrganization = React.lazy(() => import("./pages/new-organization/new-organization"));
const Organization = React.lazy(() => import("./pages/organization/organization"));
const JoinOrganization = React.lazy(() => import("./pages/join-organization/join-organization"));
const DPAForm = React.lazy(() => import("./pages/dpa-form/dpa-form"));
const Upgrade = React.lazy(() => import("./pages/upgrade/upgrade"));
const SuccessFullPayment = React.lazy(() => import("./pages/successfull-payment/successfull-payment"));
const WaitList = React.lazy(() => import("./pages/wait-list/wait-list"));
const AiScan = React.lazy(() => import("./pages/ai-scan/ai-scan"));
const ConnectUser = React.lazy(() => import("./pages/connect-user/connect-user"));

firebase.initializeApp({
    apiKey: "AIzaSyCg6ActQTzDtTwjSBOBx6px-TyGyZlAEnI",
    authDomain: "noai-19c19.firebaseapp.com",
    projectId: "noai-19c19",
    storageBucket: "noai-19c19.appspot.com",
    messagingSenderId: "589275210464",
    appId: "1:589275210464:web:6a7e29cb8fdd8d78f52685",
});

export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const functions = firebase.app().functions("europe-west1");

export const freeTrialWithoutPaymentCardEnabled = true;

function App() {
    const [user] = useAuthState(auth);

    useEffect(() => {
        // Preload lazy-loaded components when the user is authenticated
        const preloadComponents = async () => {
            try {
                // Trigger loading of all lazy components by importing them
                await Promise.all([
                    import("./pages/dashboard/dashboard"),
                    import("./pages/scans/scans"),
                    import("./pages/scan/scan"),
                    import("./organisms/navbar/navbar"),
                    import("./pages/user/user"),
                    import("./pages/delete-user/delete-user"),
                    import("./pages/create-user/create-user"),
                    import("./pages/unavailable/unavailable"),
                    import("./pages/data-administration/data-administration"),
                    import("./pages/delete-data/delete-data"),
                    import("./pages/new-test-scan/new-test-scan"),
                    import("./pages/experimental-new-scan/experimental-new-scan"),
                    import("./pages/new-organization/new-organization"),
                    import("./pages/organization/organization"),
                    import("./pages/join-organization/join-organization"),
                    import("./pages/dpa-form/dpa-form"),
                    import("./pages/upgrade/upgrade"),
                    import("./pages/successfull-payment/successfull-payment"),
                    import("./pages/wait-list/wait-list"),
                    import("./pages/ai-scan/ai-scan"),
                    import("./pages/connect-user/connect-user"),
                ]);
            } catch (error) {
                console.warn("Failed to preload some components:", error);
            }
        };

        if (user) {
            preloadComponents();
        }
    }, [user]);

    if (user)
        return (
            <Suspense fallback={<div style={{ width: "100%", height: "100vh", backgroundColor: "white", display: "flex", alignItems: "center", justifyContent: "center" }}>Loading...</div>}>
                <MantineProvider withGlobalStyles withNormalizeCSS>
                    <UserAndOrganzationContextProvider firestore={firestore} auth={auth}>
                        <Router>
                            <Toaster />
                            <ScrollToTop />
                            <Suspense fallback={<div style={{ width: "100%", height: "60px", backgroundColor: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center" }}>Loading navigation...</div>}>
                                <Navbar />
                            </Suspense>
                            <Suspense fallback={<div style={{ width: "100%", height: "calc(100vh - 60px)", backgroundColor: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center" }}>Loading page...</div>}>
                                <Routes>
                                    {/*<Route path="/profile/"> <Profile /> </Route>*/}
                                    <Route path="/*" element={<Dashboard />} />
                                    <Route path="/home" element={<Dashboard />}>
                                        {" "}
                                    </Route>

                                    <Route path="/new-scan" element={<ExperimentalNewScan firestore={firestore} auth={auth} firebase={firebase} />} />
                                    <Route path="/new-scan/:id" element={<ExperimentalNewScan firestore={firestore} auth={auth} firebase={firebase} />} />

                                    <Route path="/check-ai" element={<AiScan firestore={firestore} auth={auth} firebase={firebase} />} />
                                    <Route path="/check-ai/:id" element={<AiScan firestore={firestore} auth={auth} firebase={firebase} />} />

                                    {/* <Route path="/new-file-scan" element={<NewFileScan firestore={firestore} auth={auth} firebase={firebase} />} />
                            <Route path="/new-file-scan/:id" element={<NewFileScan firestore={firestore} auth={auth} firebase={firebase} />} /> */}

                                    <Route path="/scans" element={<Scans firestore={firestore} auth={auth} />} />
                                    <Route path="/scans/:id" element={<Scans firestore={firestore} auth={auth} />} />
                                    <Route path="/scan/:id" element={<Scan firestore={firestore} auth={auth} firebase={firebase} />} />
                                    <Route path="/scan/:id/add-follow-up-questions" element={<Scan firestore={firestore} auth={auth} firebase={firebase} />} />

                                    <Route path="/user" element={<User auth={auth} firestore={firestore} />} />
                                    <Route path="/delete-user" element={<DeleteUser auth={auth} />} />
                                    <Route path="/data-administration" element={<DataAdministration />} />
                                    <Route path="/delete-data" element={<DeleteData auth={auth} firestore={firestore} />} />
                                    <Route path="/connect-user" element={<ConnectUser />} />

                                    <Route path="/unavailable" element={<Unavailable />} />

                                    <Route path="/new-organization" element={<NewOrganization firestore={firestore} auth={auth} firebase={firebase} />} />
                                    <Route path="/new-organization/:dpa" element={<NewOrganization firestore={firestore} auth={auth} firebase={firebase} />} />

                                    <Route path="/organization" element={<Organization firestore={firestore} auth={auth} firebase={firebase} />} />
                                    <Route path="/DPA/:organizaionId" element={<DPAForm firestore={firestore} auth={auth} firebase={firebase} />} />

                                    {/* <Route path="/new-test-scan" element={<NewTestScan firestore={firestore} auth={auth} firebase={firebase} />} /> */}
                                    {/* <Route path="/x-new-scan" element={<ExperimentalNewScan firestore={firestore} auth={auth} firebase={firebase} />} /> */}

                                    <Route path="/join/:id/:name" element={<JoinOrganization firebase={firebase} />} />
                                    <Route path="/new-test-scan" element={<NewTestScan firestore={firestore} auth={auth} firebase={firebase} />} />
                                    {/* <Route path="/x-new-scan" element={<ExperimentalNewScan firestore={firestore} auth={auth} firebase={firebase} />} /> */}

                                    <Route path="/upgrade" element={<Upgrade firestore={firestore} auth={auth} firebase={firebase} />} />

                                    <Route path="/success" element={<SuccessFullPayment />} />

                                    <Route path="/waitlist" element={<WaitList firestore={firestore} auth={auth} firebase={firebase} />} />
                                </Routes>
                            </Suspense>
                            {/* <Footer auth={auth} firestore={firestore} /> */}
                        </Router>
                    </UserAndOrganzationContextProvider>
                </MantineProvider>
            </Suspense>
        );

    return (
        <Suspense
            fallback={
                <div
                    style={{
                        width: "100%",
                        height: "100vh",
                        backgroundColor: "#f5f5f5",
                    }}
                >
                    loading...
                </div>
            }
        >
            <Router>
                <Routes>
                    <Route path="/sign-in" element={<SignIn auth={auth} />} />
                    <Route path="/sign-up" element={<CreateUser auth={auth} />} />
                    <Route path="/join/:id/:name" element={<JoinOrganizationAuth auth={auth} firestore={firestore} />} />

                    <Route path="/deleted" element={<SuccessfullDeletion />} />

                    <Route path="/*" element={<LandingPage />} />

                    <Route
                        path="/precision"
                        element={
                            <>
                                <ScrollToTop />
                                <NavbarLandingPage />
                                <PrecisionPage />
                                <ContactUsSegment />
                            </>
                        }
                    />

                    <Route
                        path="/privacy"
                        element={
                            <>
                                <ScrollToTop />
                                <NavbarLandingPage />
                                <PrivacyPage />
                                <ContactUsSegment />
                            </>
                        }
                    />

                    <Route
                        path="/privacy-policy"
                        element={
                            <>
                                <ScrollToTop />
                                <NavbarLandingPage />
                                <PrivacyPolicyPage />
                                <ContactUsSegment />
                            </>
                        }
                    />

                    <Route
                        path="/terms-of-service"
                        element={
                            <>
                                <ScrollToTop />
                                <NavbarLandingPage />
                                <TermsOfServicePage />
                                <ContactUsSegment />
                            </>
                        }
                    />

                    <Route
                        path="/gdpr"
                        element={
                            <>
                                <ScrollToTop />
                                <NavbarLandingPage />
                                <GDPRPage />
                                <ContactUsSegment />
                            </>
                        }
                    />

                    <Route
                        path="/responsible-reporting"
                        element={
                            <>
                                <ScrollToTop />
                                <NavbarLandingPage />
                                <ResponsibleReportingPage />
                                <ContactUsSegment />
                            </>
                        }
                    />

                    <Route path="/pricing" element={<PricingPage />} />

                    <Route
                        path="/about-us"
                        element={
                            <>
                                <ScrollToTop />
                                <NavbarLandingPage />
                                <AboutUsPage />
                                <ContactUsSegment />
                            </>
                        }
                    />
                    <Route path="/contact-us" element={<ContactUsPage />} />

                    {/* <Route path="/adwriter" element={<AdWriter />} /> */}
                </Routes>
            </Router>
        </Suspense>
    );
}

export default App;
